import { graphql } from 'react-relay';

export const gqlInvsysLogShopBusinessEngagementEvents = graphql`
  mutation invsysLogShopBusinessEngagementEventsMutation($events: [InvsysLogBusinessEngagementEventArgs!]!) {
    invsysLogShopBusinessEngagementEvents(events: $events) {
      success
    }
  }
`;
